// tslint:disable:no-any
export type Debounced<T extends (...args: Array<any>) => any> = T & {
  /**
   * Cancels any pending debounce.
   */
  cancel: () => void;
};

export function debounce<T extends (...args: Array<any>) => any>(
  func: T,
  delay: number
): Debounced<T> {
  let activeDebounce: number | undefined;

  const debounced = function(this: any, ...args: Array<any>): any {
    if (activeDebounce) {
      clearTimeout(activeDebounce);
    }

    activeDebounce = window.setTimeout(() => {
      func.apply(this, args);
      activeDebounce = undefined;
    }, delay);
  } as Debounced<T>;

  debounced.cancel = () => clearTimeout(activeDebounce);

  return debounced;
}

export default debounce;



// WEBPACK FOOTER //
// ./src/app/utils/debounce.ts